import React, { useState, useEffect }  from 'react'
import AdminTitle from '../AdminTitle'
import { useParams } from 'react-router-dom';
import axios from 'axios'

type Applicant = {
  job: {id: number, company_name: string},
  profile_image: {url: string} | null,
  show_image: boolean,
  card_image_1: {url: string} | null,
  card_image_2: {url: string} | null,
  card_image_3: {url: string} | null,
  visa_status: string,
  first_name: string,
  middle_name: string,
  last_name: string,
  first_name_kana: string,
  middle_name_kana: string,
  last_name_kana: string,
  birth_date: string,
  gender: string,
  phone_number: string,
  has_japanese_phone: string,
  email: string,
  line_id: string,
  facebook_id: string,
  living_in_japan: string,
  postal_code: string,
  prefecture: string,
  city: string,
  address: string,
  building_name: string,
  nearest_station: string,
  education: string,
  education_other: string,
  japanese_level: string,
  japanese_reading: string,
  japanese_writing: string,
  japanese_speaking: string,
  driving_license: string,
  parttime_experience: string,
  work_experience: string,
  passport_image: {url: string} | null,
  driving_license_image: {url: string} | null,
  nationality: string,
}

export default function ApplicantShow() {
  // 応募者情報の状態管理
  const [applicant, setApplicant] = useState<Applicant>({
    job: {id: 0, company_name:''},
    profile_image: null,
    show_image: false,
    card_image_1: null,
    card_image_2: null,
    card_image_3: null,
    visa_status: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    first_name_kana: '',
    middle_name_kana: '',
    last_name_kana: '',
    birth_date: '',
    gender: '',
    phone_number: '',
    has_japanese_phone: '',
    email: '',
    line_id: '',
    facebook_id: '',
    living_in_japan: '',
    postal_code: '',
    prefecture: '',
    city: '',
    address: '',
    building_name: '',
    nearest_station: '',
    education: '',
    education_other: '',
    japanese_level: '',
    japanese_reading: '',
    japanese_writing: '',
    japanese_speaking: '',
    driving_license: '',
    parttime_experience: '',
    work_experience: '',
    passport_image: null,
    driving_license_image: null,
    nationality: '',
  })

  // 現在のページのidを取得
  const query = useParams().id

  // APIからデータを取得
  useEffect(() => {
    axios.get(`/api/v1/applicants/${query}`)
    .then (res => {
      setApplicant({
        job: res.data.applicant.job,
        profile_image: res.data.applicant.profile_image,
        show_image: res.data.applicant.show_image,
        card_image_1: res.data.applicant.card_image_1,
        card_image_2: res.data.applicant.card_image_2,
        card_image_3: res.data.applicant.card_image_3,
        visa_status: res.data.applicant.visa_status,
        first_name: res.data.applicant.first_name,
        middle_name: res.data.applicant.middle_name,
        last_name: res.data.applicant.last_name,
        first_name_kana: res.data.applicant.first_name_kana,
        middle_name_kana: res.data.applicant.middle_name_kana,
        last_name_kana: res.data.applicant.last_name_kana,
        birth_date: res.data.applicant.birth_date,
        gender: res.data.applicant.gender,
        phone_number: res.data.applicant.phone_number,
        has_japanese_phone: res.data.applicant.has_japanese_phone,
        email: res.data.applicant.email,
        line_id: res.data.applicant.line_id,
        facebook_id: res.data.applicant.facebook_id,
        living_in_japan: res.data.applicant.living_in_japan,
        postal_code: res.data.applicant.postal_code,
        prefecture: res.data.applicant.prefecture,
        city: res.data.applicant.city,
        address: res.data.applicant.address,
        building_name: res.data.applicant.building_name,
        nearest_station: res.data.applicant.nearest_station,
        education: res.data.applicant.education,
        education_other: res.data.applicant.education_other,
        japanese_level: res.data.applicant.japanese_level,
        japanese_reading: res.data.applicant.japanese_reading,
        japanese_writing: res.data.applicant.japanese_writing,
        japanese_speaking: res.data.applicant.japanese_speaking,
        driving_license: res.data.applicant.driving_license,
        parttime_experience: res.data.applicant.parttime_experience,
        work_experience: res.data.applicant.work_experience,
        passport_image: res.data.applicant.passport_image,
        driving_license_image: res.data.applicant.driving_license_image,
        nationality: res.data.applicant.nationality,
      })
    })
    .catch (err => {
      console.log(err);
      alert("データの取得に失敗しました。");
    });
  }, [query]);

  return (
    <>
      <AdminTitle title={'応募者詳細'} />
      <div className='admin-bg__color'>
        <div className='breadcrumb'>
          <ul>
            <li><a href='/admins/applicants'>応募者一覧</a></li>
            <li>{`${applicant.first_name}${applicant.middle_name}${applicant.last_name}`}</li>
          </ul>
        </div>
        <div className='admin-card'>
          <div className='admin-card__container'>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>応募した求人</div>
              </div>
              <div className='admin-show__group--value'>
                {/* BrowserRouter内で括られていない画面同士なので、<Link>ではなく<a>タグでリンク作成 */}
                <a href={`/admins/jobs/${applicant.job.id}`}>{applicant.job.company_name}</a>
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>プロフィール写真</div>
              </div>
              <div className='admin-show__group--value'>
                { applicant.profile_image && <img src={applicant.profile_image.url} width='173' height='115' /> }
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>スカウトに写真を表示してもよろしいでしょうか？</div>
              </div>
              <div className='admin-show__group--value'>
                { applicant.show_image ? 'はい' : 'いいえ' }
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>在留カードの写真</div>
              </div>
              <div className='admin-show__group--value'>
                { applicant.card_image_1 && <img src={applicant.card_image_1.url} width='173' height='115' /> }
              </div>
              <div className='admin-show__group--value'>
                { applicant.card_image_2 && <img src={applicant.card_image_2.url} width='173' height='115' /> }
              </div>
              <div className='admin-show__group--value'>
                { applicant.card_image_3 && <img src={applicant.card_image_3.url} width='173' height='115' /> }
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>在留種別</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.visa_status}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>名前（アルファベット）</div>
              </div>
              <div className='admin-show__group--value'>
                {`${applicant.first_name}　${applicant.middle_name}　${applicant.last_name}`}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>名前（カタカナ）</div>
              </div>
              <div className='admin-show__group--value'>
                {`${applicant.first_name_kana}　${applicant.middle_name_kana}　${applicant.last_name_kana}`}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>生年月日</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.birth_date}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>性別</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.gender}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>国籍</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.nationality}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>電話番号</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.phone_number}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>日本で契約した電話の有無</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.has_japanese_phone ? '契約あり' : '契約なし'}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>メールアドレス</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.email}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>LINE</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.line_id}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>Facebook</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.facebook_id}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>日本に住んでいますか？</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.living_in_japan ? 'はい' : 'いいえ'}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>住所</div>
              </div>
              <div className='admin-show__group--value'>
                {`〒${applicant.postal_code}\n`} {applicant.prefecture}{applicant.city}{applicant.address}{applicant.building_name}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>最寄駅</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.nearest_station}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>学歴</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.education}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>学歴その他</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.education_other}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>日本語レベル</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.japanese_level}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>日本語リーディングレベル</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.japanese_reading}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>日本語ライティングレベル</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.japanese_writing}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>日本語スピーキングレベル</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.japanese_speaking}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>運転免許</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.driving_license}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>アルバイト経験</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.parttime_experience}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>職歴</div>
              </div>
              <div className='admin-show__group--value'>
                {applicant.work_experience}
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>パスポート画像</div>
              </div>
              <div className='admin-show__group--value'>
                { applicant.passport_image &&
                    applicant.passport_image.url ? ( <img src={applicant.passport_image.url} width='173' height='115' /> ) : ( <p>画像がアップロードされていません</p> ) }
              </div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>運転免許証画像</div>
              </div>
              <div className='admin-show__group--value'>
                { applicant.driving_license_image &&
                    applicant.driving_license_image.url ? ( <img src={applicant.driving_license_image.url} width='173' height='115' /> ) : ( <p>画像がアップロードされていません</p> ) }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
